import { NavigateFunction } from "react-router-dom"
import { LayoutStateInterface } from "../../GlobalStates/LayoutState"
import { LoginStateInterface } from "../../GlobalStates/LoginState"

export class ClsLogout {

  public efetuarLogout (
    setLoginState: React.Dispatch<React.SetStateAction<LoginStateInterface>>,
    setLayoutState: React.Dispatch<React.SetStateAction<LayoutStateInterface>>,
    navigate: NavigateFunction
  ) {

    localStorage.removeItem( 'token' )

    // Reset LoginState
    setLoginState( {
      logado: false,
      idUnidadeAtual: 0,
      idUsuario: 0,
      permissoes: [],
      token: '',
      nome: ''
    } )

    // Reset LauoutState
    setLayoutState( {
      descricaoUnidadeAtual: '',
      opcaoNavegacaoInferior: -1,
      exibirMenu: false,
      opcoesMenu: []
    } )

    navigate( '/' )
  }
}